import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

/**
 * Flattens nested objects into a single-level object.
 * Example: { user: { name: "John", email: "john@example.com" } }
 * Becomes: { user_name: "John", user_email: "john@example.com" }
 */
const flattenObject = (obj, prefix = "") => {
  let flattened = {};
  for (let key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = obj[key];

      // Skip null or undefined nested objects completely
      if (
        typeof value === "object" &&
        value !== null &&
        !Array.isArray(value)
      ) {
        // Skip empty objects too
        if (Object.keys(value).length > 0) {
          Object.assign(flattened, flattenObject(value, `${prefix}${key}_`));
        }
        // Else skip entirely, no keys to add
      } else if (value !== null && value !== undefined) {
        // Only assign if the value is not null/undefined
        flattened[`${prefix}${key}`] = value;
      }
    }
  }
  return flattened;
};

export const exportToExcel = (
  data,
  filePrefix = "Export",
  sheetName = "Sheet1",
  headerMap = {}
) => {
  if (!data || data.length === 0) {
    toast.warning("No data available to export!");
    return;
  }

  const flattenedData = data.map((item) => flattenObject(item));

    // Map keys to custom headers if provided
  // const mappedData = flattenedData.map((row) =>
  //   Object.fromEntries(
  //     Object.entries(row).map(([key, value]) => [
  //       headerMap[key] || key, // Use custom header if exists, else fallback
  //       value !== null && value !== undefined ? value : "N/A",
  //     ])
  //   )
  // );
    const mappedData = flattenedData.map((row) => {
    const orderedRow = {};
    Object.keys(headerMap).forEach((key) => {
      orderedRow[headerMap[key]] =
        row[key] !== null && row[key] !== undefined ? row[key] : "N/A";
    });
    return orderedRow;
  });

  const now = new Date();
  const formattedDateTime = now
    .toISOString()
    .replace(/T/, "_")
    .replace(/:/g, "-")
    .split(".")[0];
  const fileName = `${filePrefix}_${formattedDateTime}.xlsx`;

  const worksheet = XLSX.utils.json_to_sheet(mappedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

  XLSX.writeFile(workbook, fileName);
  toast.success("Details exported successfully");
};
